var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{class:['pf-annotation-position__tag']},[_c('rect',{attrs:{"stroke":_vm.fill,"stroke-width":2,"fill":_vm.fill,"x":_vm.tagX,"y":_vm.tagY,"width":_vm.width,"height":_vm.height}}),_c('text',{attrs:{"fill":"white","x":_vm.textX,"y":_vm.textY}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }